import { user, UserListResponse } from '@fireflyhealth/api'

/**
 * Generated snake_case provider as returned by `GET /user/?type=provider`.
 * Consumers read this shape directly via the `providers` Redux slice.
 */
export type Provider = UserListResponse['results'][number]

/** A provider's display name (first + last), falling back to 'Unknown' when both are blank. */
export const providerName = (provider: Provider): string =>
  `${provider.first_name ?? ''} ${provider.last_name ?? ''}`.trim() || 'Unknown'

// `UserListLimitOffsetPagination.default_limit` is `None` on the backend, so the
// endpoint only returns the paginated envelope ({ count, next, results }) when a
// `limit` is supplied — without it the response is a bare array and `.results`
// is undefined. We therefore always page explicitly and accumulate `.results`.
const PAGE_LIMIT = 1000

export async function fetchProviders(): Promise<Provider[]> {
  const providers: Provider[] = []
  let offset = 0
  let hasMore = true

  while (hasMore) {
    const { results, next } = (
      await user.list({ params: { type: 'provider', limit: PAGE_LIMIT, offset } })
    ).data
    providers.push(...results)
    // `next` is DRF's authoritative "more pages" signal; the empty-page check is
    // a belt-and-braces guard against a non-terminating loop.
    hasMore = Boolean(next) && results.length > 0
    offset += PAGE_LIMIT
  }

  return providers
}
